import Logo from "@/components/Logo";
import { Button } from "@/components/ui/Button";
import useStore from "@/store";
import Head from "next/head";
import Link from "next/link";
import ParagraphSection from "./components/ParagraphSection";
import { useTranslation } from "react-i18next";

const FAQ = () => {
  const { t } = useTranslation("faq"); // ← NEW
  const isLoggedIn = useStore(state => state.isLoggedIn);

  return (
    <div className="flex flex-col gap-4 md:gap-6 p-4 md:p-6">
      <Head>
        <title>{t("page_title")}</title>
      </Head>

      <Link passHref href={isLoggedIn ? "/dashboard" : "/"}>
        <a className="mx-auto">
          <Logo />
        </a>
      </Link>

      <h1 className="text-2xl md:text-3xl text-center font-semibold">{t("main_title")}</h1>

      <ParagraphSection title={t("what_is_digital_home_title")}>
        {t("what_is_digital_home_body")}
      </ParagraphSection>

      <ParagraphSection title={t("how_to_create_account_title")}>
        {t("how_to_create_account_body")}
      </ParagraphSection>

      <ParagraphSection title={t("how_to_reset_password_title")}>
        {t("how_to_reset_password_body")}
      </ParagraphSection>

      <ParagraphSection title={t("what_data_we_collect_title")}>
        {t("what_data_we_collect_body")}
      </ParagraphSection>

      <ParagraphSection title={t("how_we_use_data_title")}>
        {t("how_we_use_data_body")}
      </ParagraphSection>

      <ParagraphSection title={t("security_measures_title")}>
        {t("security_measures_body")}
      </ParagraphSection>

      <ParagraphSection title={t("contact_support_title")}>
        {t("contact_support_body")}
      </ParagraphSection>

      <div className="flex flex-col gap-2 items-center mx-auto mt-8 text-muted-foreground">
        {t("more_questions_text")}
        <Link passHref href="mailto:support@digital-home.org">
          <Button className="py-0 h-fit" variant="link">
            support@digital-home.org
          </Button>
        </Link>
        <Link passHref href="tel:0665044458">
          <Button className="py-0 h-fit" variant="link">
            0665044458
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default FAQ;
